export const modifiers = {
    default: 'default',
    none: 'none',
    swatch: 'swatch',
};
export const selectionTypes = {
    multiple: 'multiple',
    single: 'single',
};
export const optionTypes = {
    [selectionTypes.multiple]: 'checkbox',
    [selectionTypes.single]: 'radio',
};
